import tablelist from './tablelist';
export default tablelist;



// WEBPACK FOOTER //
// ./src/components/tablelist/index.js